<xng-breadcrumb [separator]="iconTemplate">>
  <ng-container *xngBreadcrumbItem="let breadcrumb; let info = info">
    <ng-container>
        <mat-icon class="t_left" *ngIf="info" style="margin-right:3px;">{{ info.icon }}</mat-icon> {{ breadcrumb | translate }}
        </ng-container>
  </ng-container>
</xng-breadcrumb>

<ng-template #iconTemplate>
  <mat-icon>arrow_right</mat-icon>
</ng-template>
